
import React, { useState } from 'react';
import { User, UserRole } from '../types';

interface Props {
  allUsers: User[];
  onLogin: (user: User) => void;
}

const Auth: React.FC<Props> = ({ allUsers, onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('请输入用户名和密码');
      return;
    }

    // 在传入的用户数据库中查找匹配项
    const user = allUsers.find(u => u.username === username && u.password === password);

    if (user) {
      onLogin(user);
    } else {
      setError('用户名或密码错误。请联系管理员创建账号。');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-indigo-600 to-indigo-800 p-6">
      <div className="bg-white/95 backdrop-blur-xl p-10 rounded-[2.5rem] shadow-2xl w-full max-w-md border border-white/20">
        <div className="text-center mb-10">
          <div className="bg-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center text-white font-bold text-3xl mx-auto mb-4 shadow-lg">
            V
          </div>
          <h1 className="text-3xl font-black text-slate-800 tracking-tight">VocabMaster</h1>
          <p className="text-slate-500 mt-2 font-medium">请登录以开始学习之旅</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-black text-slate-700 mb-2 ml-1 uppercase tracking-wider">用户名</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-5 py-4 rounded-2xl bg-white text-slate-900 border border-slate-200 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 outline-none transition-all placeholder:text-slate-400"
              placeholder="请输入您的用户名"
            />
          </div>
          <div>
            <label className="block text-sm font-black text-slate-700 mb-2 ml-1 uppercase tracking-wider">密码</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-5 py-4 rounded-2xl bg-white text-slate-900 border border-slate-200 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 outline-none transition-all placeholder:text-slate-400"
              placeholder="请输入您的密码"
            />
          </div>

          {error && (
            <div className="flex items-start gap-2 text-red-500 text-sm font-bold bg-red-50 p-3 rounded-xl border border-red-100 leading-tight">
              <i className="fas fa-exclamation-circle mt-0.5"></i>
              <span>{error}</span>
            </div>
          )}
          
          <button 
            type="submit"
            className="w-full py-5 bg-blue-600 hover:bg-blue-700 text-white font-bold text-xl rounded-2xl shadow-xl shadow-blue-200 transition-all active:scale-[0.98] mt-4"
          >
            登录系统
          </button>
        </form>

        <div className="mt-12 text-center">
          <p className="text-slate-400 text-[10px] font-black uppercase tracking-widest">
            本系统由 AI 提供动力 · 仅限已授权用户
          </p>
        </div>
      </div>
    </div>
  );
};

export default Auth;
